import { Documento } from '../../models/Documento';


export const listaFormularios: Documento[] = [
    {
        id: 1,
        titulo: 'Incorporación de nuevos estudiantes al sistema',
        descripcion: 'Incorporación de nuevos estudiantes al sistema',
        urlpdf: 'https://drive.google.com/file/d/1I022sdhVB5AUGTRmb1xJMmDIcerClN-F/view?usp=sharing'

    },
    {
        id: 2,
        titulo: 'Inscripción por Organización de Cursada',
        descripcion: 'Inscripción por Organización de Cursada',
        urlpdf: 'https://drive.google.com/file/d/1SDuzxq2TfwvS7fO7h08dzALnCM-wnbrT/view?usp=sharing'
    },
    {
        id: 3,
        titulo: 'Instancia evaluativa extraordinaria-MARZO',
        descripcion: 'Instancia evaluativa extraordinaria-MARZO',
        urlpdf: 'https://drive.google.com/file/d/1SHoTnepbUuKcMYLjDXHHJU7qLWY1sjLK/view?usp=sharing'
    },
    {
        id: 4,
        titulo: 'Pasaje de ciclo 2024 al 2025',
        descripcion: 'Pasaje de ciclo 2024 al 2025',
        urlpdf: 'https://drive.google.com/file/d/1VhXBDmYK7mPCg_64zZ0xP4CJR3d14uUh/view?usp=sharing'
    },
    {
        id: 5,
        titulo: 'GESTIÓN DE PASES JURISDICCIONALES en EDUCACIÓN PRIMARIA',
        descripcion: 'GESTIÓN DE PASES JURISDICCIONALES en EDUCACIÓN PRIMARIA',
        urlpdf: 'https://drive.google.com/file/d/17N_Qw0BxECFEfJn419XA5QzqqP1nlWsT/view?usp=sharing'
    },
    {
        id: 6,
        titulo: 'Procedimiento para borrar un estudiante inscripto en una sección',
        descripcion: 'Procedimiento para borrar un estudiante inscripto en una sección',
        urlpdf: 'https://drive.google.com/file/d/1Lk6ojlkeyLyHNvaRr35HEBS8uce3JrTd/view?usp=sharing'
    },
    {
        id: 7,
        titulo: 'PROCEDIMIENTO PARA AGREGAR EVENTOS INSTITUCIONALES',
        descripcion: 'PROCEDIMIENTO PARA AGREGAR EVENTOS INSTITUCIONALES',
        urlpdf: 'https://drive.google.com/file/d/1Lk6ojlkeyLyHNvaRr35HEBS8uce3JrTd/view?usp=sharing'
    }
    ,
    {
        id: 8,
        titulo: 'Procedimientos de carga de calificaciones del 1er bimestre  de Educacion primaria 2025',
        descripcion: 'Procedimientos de carga de calificaciones del 1er bimestre  de Educacion primaria 2025',
        urlpdf: 'https://drive.google.com/file/d/1hfS3Nx1YBcRlFeZYTDhTGzwzzcHII3VJ/view?usp=sharing'
    }
    ,
    {
        id: 9,
        titulo: 'Guía de Carga de Asistencias',
        descripcion: 'Guía de Carga de Asistencias',
        urlpdf: 'https://drive.google.com/file/d/1L-XZxSXUy3VVhUQRK0Kr6tGmdBh2WARc/view?usp=sharing'
    }
     ,
    {
        id: 10,
        titulo: 'Procedimientos de carga de calificaciones del 1er Trimestre de Educacion SECUNDARIA 2025',
        descripcion: 'Procedimientos de carga de calificaciones del 1er Trimestre de Educacion SECUNDARIA 2025',
        urlpdf: 'https://drive.google.com/file/d/1Dsjx8GsPzuoDuH3ftiAZkXT5UDlYagDP/view?usp=sharing'
    }
]

export const formulariosRa: Documento[] = [
  {
      id: 1,
      titulo: 'ADULTOS-TP-2024',
      descripcion: 'ADULTOS-TP-2024',
      urlpdf: 'https://drive.google.com/file/d/1ZTxhHFf8b_fKLbnw_9vPQb_6GKu5Htr0/view?usp=sharing'
  },
  {
      id: 2,
      titulo: 'ARTISTICA-2024',
      descripcion: 'ARTISTICA-2024',
      urlpdf: 'https://drive.google.com/file/d/1YD7iiqEkqjq8fujgwHEHpL6I4wAkBjTj/view?usp=sharing'
  },
  {
      id: 3,
      titulo: 'COMUN-TP-2024 PRIMARIO',
      descripcion: 'COMUN-TP-2024 PRIMARIO',
      urlpdf: 'https://drive.google.com/file/d/1pQdXntVOhQ_7rbJ9_gugnxOuar7Y7jfj/view?usp=sharing'
  },
  {
      id: 4,
      titulo: 'COMUN-TP-2024-INICIAL',
      descripcion: 'COMUN-TP-2024-INICIAL',
      urlpdf: 'https://drive.google.com/file/d/186uVlwyjE8SDZbCFSMCkeW6vpuTlmr7z/view?usp=sharing'
  },
  {
      id: 5,
      titulo: 'COMUN-TP-2024-SECUNDARIO',
      descripcion: 'COMUN-TP-2024-SECUNDARIO',
      urlpdf: 'https://drive.google.com/file/d/1z34aY5UFkBWxFxo3mzun4_qESYMdIyv6/view?usp=sharing'
  },
  {
      id: 6,
      titulo: 'COMUN-TP-2024INICIAL Y PRIMARIO',
      descripcion: 'COMUN-TP-2024INICIAL Y PRIMARIO',
      urlpdf: 'https://drive.google.com/file/d/1ck2YuUrvNDwAVF-odBog62VTWhlUxf7a/view?usp=sharing'
  },
  {
      id: 7,
      titulo: 'DOMICILIARIA-2024',
      descripcion: 'DOMICILIARIA-2024',
      urlpdf: 'https://drive.google.com/file/d/12HdGaFxhv8FRmKCMLu7d7s6uBcwX5Byu/view?usp=sharing'
  },
  {
      id: 8,
      titulo: 'ESPECIAL-2024',
      descripcion: 'ESPECIAL-2024',
      urlpdf: 'https://drive.google.com/file/d/1kDyQ3nYA8Ei-6Jf-kRc-CQuWrWqavWBs/view?usp=sharing'
  },
  {
      id: 9,
      titulo: 'FORM-PROF-CAP-LABORAL-2024',
      descripcion: 'FORM-PROF-CAP-LABORAL-2024',
      urlpdf: 'https://drive.google.com/file/d/1ooktY8JftnnVLc0N9zpnHjcOL7YUNT-3/view?usp=sharing'
  },
  {
      id: 10,
      titulo: 'SUPERIOR-TP-2024',
      descripcion: 'SUPERIOR-TP-2024',
      urlpdf: 'https://drive.google.com/file/d/14q6LH7juB1tEyMCbxfAla-hvAXCsWisU/view?usp=sharing'
  }
]
